// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3Mf3W","head":"ProcedureTableInfo_head__1XvKC"};